import { render, staticRenderFns } from "./FooterInfoMenu.vue?vue&type=template&id=20e16b06"
import script from "./FooterInfoMenu.vue?vue&type=script&lang=js"
export * from "./FooterInfoMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports